import React, {useState} from "react";
import prodVuoto from "../../prodottoVuoto";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function ToolsEReference(props) {
    const prodottoTemp = props.prodottoTemp;
    const setProdottoTemp = props.setProdottoTemp;
    const setProdottoRiferimento = props.setProdottoRiferimento;
    const classiTastoCopiaInAlto = props.classiTastoCopiaInAlto;
    const prodottoRiferimento = props.prodottoRiferimento;
    const InputCodice = props.InputCodice;
    const InputCodiceProd = props.InputCodiceProd;
    const InputNomeProd = props.InputNomeProd;
    const lang = props.lang;
    const classiTastoSblocco = props.classiTastoSblocco;
    const listaNomiProdotto = props.listaNomiProdotto;
    const utente= props.utente;
    const onReferenceSearchResults = props.onReferenceSearchResults;

    const [testoDaMaiuscolare, setTestoDaMaiuscolare] = useState("");

    const handleReferenceSearchResults = (data, searchInfo = {}) => {
        if (typeof onReferenceSearchResults === "function") {
            onReferenceSearchResults(data, searchInfo);
            return;
        }
        const products = Array.isArray(data) ? data.filter(Boolean) : [];
        setProdottoRiferimento(products[0] || prodVuoto);
    };

    return (
        <div className="">
            {(prodottoTemp.appuntiImport && prodottoTemp.appuntiImport.length>0) && <div className={"br4 "+stilePulsanti.riquadroClassesRed}>
            <h3>Note importazione</h3>
            {prodottoTemp.appuntiImport.map(messaggio => <p>{messaggio}</p>)}
            </div>}
            <h3>Tasti copia comodi</h3>
            <button onClick={(e) => navigator.clipboard.writeText("• ").then(e.preventDefault())} className={classiTastoCopiaInAlto}>punto+spazio per elenchi</button>
            <button onClick={(e) => navigator.clipboard.writeText("À").then(e.preventDefault())} className={classiTastoCopiaInAlto}>À</button>
            <button onClick={(e) => navigator.clipboard.writeText("È").then(e.preventDefault())} className={classiTastoCopiaInAlto}>È</button>
            <button onClick={(e) => navigator.clipboard.writeText("Ì").then(e.preventDefault())} className={classiTastoCopiaInAlto}>Ì</button>
            <button onClick={(e) => navigator.clipboard.writeText("Ò").then(e.preventDefault())} className={classiTastoCopiaInAlto}>Ò</button>
            <button onClick={(e) => navigator.clipboard.writeText("Ù").then(e.preventDefault())} className={classiTastoCopiaInAlto}>Ù</button>
            <button onClick={(e) => navigator.clipboard.writeText("Ö").then(e.preventDefault())} className={classiTastoCopiaInAlto}>Ö</button>
            <button onClick={(e) => navigator.clipboard.writeText("ö").then(e.preventDefault())} className={classiTastoCopiaInAlto}>ö</button>
            <h3>MAIUSCOLATORE</h3>
            <input placeholder="incolla qui il testo da maiuscolare" className={stilePulsanti.inputClassesNoMeasure} type="text" value={testoDaMaiuscolare} onChange={(e) => {setTestoDaMaiuscolare(e.target.value)}} ></input>
            <p>{testoDaMaiuscolare.toUpperCase()}</p>
            <button onClick={(e) => navigator.clipboard.writeText(testoDaMaiuscolare.toUpperCase()).then(e.preventDefault())} className={classiTastoCopiaInAlto}>copialo</button>
            {/* <p>Ultimo prodotto salvato: <strong>{ultimoProdSalvato}</strong></p> */}

            {/* <h3>Appunti fissi</h3>
        <textarea type="text" rows="5" cols="50" id="appuntiFissi" name="appuntiFissi" value={appuntiFissiValue} onChange={handleChangeAppuntiFissi} className={inputClasses}></textarea> */}



            {prodottoRiferimento && <h3>Reference prodotto di riferimento</h3>}
            <InputCodice setProductFunction={setProdottoRiferimento} onSearchResults={handleReferenceSearchResults} showTasto={false} showLabels={true} showDescs={false} orientamento="tasto" utente={utente}/>
            <InputCodiceProd setProductFunction={setProdottoRiferimento} onSearchResults={handleReferenceSearchResults} showLabels={true} showDescs={false} orientamento="tasto" />
            <InputNomeProd setProductFunction={setProdottoRiferimento} onSearchResults={handleReferenceSearchResults} showLabels={true} showDescs={false} orientamento="tasto" listaNomiProdotto={listaNomiProdotto} />

            {prodottoRiferimento && prodottoRiferimento.codiceVS !== "NO DATA" && !prodottoRiferimento.shortName && prodottoRiferimento.codiceVS && <h3>{prodottoRiferimento.codiceVS}</h3>}
            {prodottoRiferimento && prodottoRiferimento.codiceVS !== "NO DATA" && prodottoRiferimento.shortName && prodottoRiferimento.shortName.it && <h3>{prodottoRiferimento.codiceVS} - {prodottoRiferimento.shortName.it}</h3>}
            {prodottoRiferimento?.descrizioniSuPS?.descBreve?.[lang] && prodottoRiferimento.codiceVS !== "NO DATA" && <p>{prodottoRiferimento.descrizioniSuPS.descBreve[lang]}</p>}
            {prodottoRiferimento && prodottoRiferimento.codiceVS !== "NO DATA" && <button onClick={(e) => {
                e.preventDefault()
                setProdottoTemp({
                    ...prodottoTemp,
                    shortName: prodottoRiferimento.shortName,
                    brand: prodottoRiferimento.brand,
                    datiUlteriori: {
                        generici: {
                            stagioneCollezione: prodottoRiferimento?.datiUlteriori?.generici?.stagioneCollezione,
                            stagioneConsigliata: prodottoRiferimento.datiUlteriori.generici.stagioneConsigliata,
                            utilizzo: prodottoRiferimento.datiUlteriori.generici.utilizzo
                        },
                        ...prodottoRiferimento.datiUlteriori,
                    },
                    categorieWebAssociate: prodottoRiferimento.categorieWebAssociate,
                    categoriaPredefinita: prodottoRiferimento.categoriaPredefinita,
                    categorieWebBotteroAssociate: prodottoRiferimento.categorieWebBotteroAssociate ?? [],
                    categoriaBotteroPredefinita: prodottoRiferimento.categoriaBotteroPredefinita ?? null,
                    descrizioniSuPS: prodottoRiferimento.descrizioniSuPS,
                    tradotto: prodottoRiferimento.tradotto,
                    strutturato: prodottoRiferimento.strutturato,
                    tradottoStrutturato: prodottoRiferimento.tradottoStrutturato,
                    appuntiImport: [`Hai copiato tutti i dati dal codice ${prodottoRiferimento.codiceVS}, attenzione a cambiare i colori e altri dati ulteriori che cambiano da quella variante`]
                })
            }} className={classiTastoSblocco}>Copia tutto quanto</button>}
            {prodottoRiferimento && <p>Copia shortname, brand, descrizioni, categorie web Viglietti e Bottero e dati ulteriori (inclusi persona e colori). Controlla persona, colori, shortname e stagione/collezione prima di salvare.</p>}
            {prodottoRiferimento?.descrizioniSuPS?.descBreve?.[lang] && prodottoRiferimento.codiceVS !== "NO DATA" && <button onClick={(e) => {
                e.preventDefault()
                setProdottoTemp({
                    ...prodottoTemp,
                    descrizioniSuPS: {
                        ...prodottoTemp.descrizioniSuPS,
                        descBreve: {
                            ...prodottoTemp.descrizioniSuPS.descBreve,
                            [lang]: prodottoRiferimento.descrizioniSuPS.descBreve[lang]
                        }
                    }
                })
            }} className={classiTastoSblocco}>Copia desc breve</button>}
            {prodottoRiferimento.descrizioniSuPS.descLunga[lang] && <p dangerouslySetInnerHTML={{ __html: prodottoRiferimento.descrizioniSuPS.descLunga[lang] }}></p>}
            

        </div>
    )



}

export default ToolsEReference;
